// extracted by mini-css-extract-plugin
export default {"modaBodyNewUser":"NewUser_modaBodyNewUser__T5X5a","greenLogo":"NewUser_greenLogo__PBFct","notesList":"NewUser_notesList__7V9Nu"};